import { Attributes, DateUtils, Misc, Model, Rules, Validation } from "@singularsystems/neo-core";

export default class CustomIssuerInvestmentCriteria extends Model.CriteriaBase {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    public entityId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Custom Issuer Investment Criteria";
    }
}